<template>
  <div class="app-wrapper">
    <!-- wl -->
    <hzindex v-if="usePublicLayout" />
    <gysindex v-else />
    
    <!-- WebSocket询盘通知组件 -->
    <InquiryNotification />
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import { watch, computed, ref } from "vue";
import gysindex from "./gysindex";
import hzindex from "./hzindex";
import InquiryNotification from "@/components/InquiryNotification/index.vue";
import useUserStore from "@/store/modules/user";
import usePermissionStore from "@/store/modules/permission";
import Cookies from "js-cookie";
import { useWindowSize } from '@vueuse/core';
import { useDebounceFn } from '@vueuse/core';

const { width } = useWindowSize();
// 使用防抖来稳定宽度值，避免频繁更新导致组件频繁创建/销毁
const debouncedWidth = ref(width.value);
const updateWidth = useDebounceFn((newWidth) => {
  debouncedWidth.value = newWidth;
}, 100);

// 监听宽度变化并防抖更新
watch(width, (newWidth) => {
  updateWidth(newWidth);
}, { immediate: true });
const userStore = useUserStore();
// 获取路由
const route = useRoute();
const usePublicLayout = computed(() => {
  const activeRecord = route.matched[route.matched.length - 1];
  const roles = Array.isArray(activeRecord?.roles) ? activeRecord.roles : [];
  return roles.includes("admin") || roles.includes("user");
});
// console.log(route.matched[0].children[0]);
// const dataInfos = ref(null);
function getInfos() {
  if (Cookies.get("Admin-Token")) {
    userStore.getInfos();

    // dataInfos.value = JSON.parse(sessionStorage.getItem("roles"))[0];
    // userStore.getInfo().then(() => {
      // usePermissionStore().generateRoutes();
    // });
  }
}
getInfos();
</script>

<style scoped lang="scss">
@import "@/assets/styles/mixin.scss";
@import "@/assets/styles/variables.module.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  background-color: rgba(244, 245, 248, 1);

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
</style>
